import Washi from 'washi';
import Modal from '../../src/components/mixins/modal';
import Cookies from 'cookies-js';
const careersPath =
  'https://sjobs.brassring.com/TGWebHost/searchopenings.aspx?partnerid=25965&siteid=5168';

const CareersModal = Washi.$.extend(
  {
    el: '#careers-modal',

    ui: {
      close: '.action-modal__inner__close',
    },

    events: {
      'click {close}': 'hide',
    },

    /**
     * https://github.com/wildlife-conservation-society/wcs/issues/1768
     */
    initialize: function () {
      if (!this.isInvalid() && window.innerWidth >= 768) {
        this.activate();
      }
    },

    isInvalid: function () {
      return Cookies.get('careersModalAppeared') === '1';
    },

    activate: function () {
      this.boundLinkClick = this.onLinkClick.bind(this);
      this.careersLink = document.querySelector(
        'a[href="' + careersPath + '"]',
      );
      if (this.careersLink) {
        this.careersLink.setAttribute('target', '_blank');
        this.careersLink.addEventListener('click', this.boundLinkClick, false);
      }
    },

    deactivate: function () {
      if (this.careersLink && this.boundLinkClick) {
        this.careersLink.removeEventListener('click', this.boundLinkClick);
      }

      Cookies.set('careersModalAppeared', '1', {
        expires: 2592000, // 30 days
      });
    },

    display: function () {
      this.show();
      this.deactivate();
    },

    onLinkClick: function (e) {
      this.display();
      e.preventDefault();
    },
  },
  Modal,
);

Washi(CareersModal);
